import { Crumb } from "./types";

/** Ends the trail on the current page: appends `label` as the terminal crumb,
 *  or delinks a trailing self-link with the same label. Idempotent — the
 *  result never ends in a linked crumb, so re-applying is a no-op. */
export const withCurrentPageCrumb = (
  crumbs: Crumb[],
  label: string | undefined,
): Crumb[] => {
  if (!label || crumbs.length === 0) {
    return crumbs;
  }
  const last = crumbs[crumbs.length - 1];
  if (!last?.link) {
    return crumbs;
  }
  if (last.label === label) {
    return [...crumbs.slice(0, -1), { label }];
  }
  return [...crumbs, { label }];
};
